import { render, staticRenderFns } from "./LiveTranscription.vue?vue&type=template&id=2aa17806&scoped=true"
import script from "./LiveTranscription.vue?vue&type=script&lang=js"
export * from "./LiveTranscription.vue?vue&type=script&lang=js"
import style0 from "./LiveTranscription.vue?vue&type=style&index=0&id=2aa17806&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa17806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa17806')) {
      api.createRecord('2aa17806', component.options)
    } else {
      api.reload('2aa17806', component.options)
    }
    module.hot.accept("./LiveTranscription.vue?vue&type=template&id=2aa17806&scoped=true", function () {
      api.rerender('2aa17806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LiveTranscription.vue"
export default component.exports